// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"styles_CheckBox__23vk1","CheckBox-input":"styles_CheckBox-input__1fpgN","is-checked":"styles_is-checked__35gW-","CheckBox-text":"styles_CheckBox-text__20lDg"};